import { fetchData } from '../global/utils/fetch'

// === DOCUMENTS ===

export function getDocuments() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/documents`,
  }
}

export function deleteDocument(documentObjectId: string) {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/documents/${documentObjectId}`,
  }
}

export async function uploadDocument(
  file: File,
  name: string,
  description?: string,
): Promise<{ documentObjectId: string; name: string; totalChunks: number }> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('name', name)
  if (description) {
    formData.append('description', description)
  }

  return fetchData({
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/documents/upload`,
    body: formData,
  })
}

// === CATEGORIES ===

export function getCategories() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/categories`,
  }
}

export function createCategory(body: { name: string; description?: string; examples?: string[] }) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/categories`,
    body,
  }
}

export function updateCategory(objectId: string, body: { name?: string; description?: string; examples?: string[] }) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/categories/${objectId}`,
    body,
  }
}

export function deleteCategoryApi(objectId: string) {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/categories/${objectId}`,
  }
}

// === EVALUATION ===

export function getEvaluationQuestions() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/evaluation-questions`,
  }
}

export function createEvaluationQuestion(body: {
  query: string
  expectedAllowed: boolean
  expectedAnswer?: string
}) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/evaluation-questions`,
    body,
  }
}

export function deleteEvaluationQuestionApi(objectId: string) {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/evaluation-questions/${objectId}`,
  }
}

export function runCategoryTests() {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/evaluation/run-tests`,
    body: {},
  }
}

export function runFullTests() {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/evaluation/run-full-tests`,
    body: {},
  }
}

// === QUERY ===

export function queryTechAssistant(body: {
  messages: Array<{ role: string; content: string }>
}) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/query`,
    body,
  }
}

// === PROMPTS ===

export function getPrompts() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/prompts`,
  }
}

export function updatePromptApi(
  promptKey: string,
  body: { promptText: string; updatedBy?: string },
) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/prompts/${promptKey}`,
    body,
  }
}

// === CHAT SESSIONS ===

export function createChatSession(body?: { createdBy?: string }) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/chat/session`,
    body: body || {},
  }
}

export function getChatSession(objectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/chat/session/${objectId}`,
  }
}

export function sendChatMessage(body: {
  sessionObjectId: string
  content: string
}) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/chat/message`,
    body,
  }
}

// === ADMIN CONVERSATION LOGS ===

export function getAdminChatLogs() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/admin/chat/logs`,
  }
}

export function getAdminSessionsForUser(createdBy: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/admin/chat/logs/${encodeURIComponent(createdBy)}`,
  }
}

export function getAdminSessionDetail(
  createdBy: string,
  sessionObjectId: string,
) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technician-assistant/admin/chat/logs/${encodeURIComponent(createdBy)}/${sessionObjectId}`,
  }
}
